import * as React from "react";
import TopBarProgress from "react-topbar-progress-indicator";

TopBarProgress.config({
  barColors: {
    0: "#ff0000",
    "1.0": "#ff0000",
  },
  shadowBlur: 5,
});

// for context
export const LoadingComponent = () => {
  return (
    <React.Fragment>
      <TopBarProgress />
    </React.Fragment>
  );
};
